// Small per-person conveniences of the Export menus, kept in this browser
// (docs/specs/EXPORTS.md): the one-time "Drag a file to your desktop or a
// folder" line under Recent Exports, gone for good after the first drag-out,
// and Recent Exports staying unfolded once the person unfolds it. Browser
// storage can be missing or refuse (private windows), so every read and
// write is guarded; losing one only brings back the default.

const DRAG_HINT_KEY = 'arvoke.exports.dragHintDone'
const KEEP_UNFOLDED_KEY = 'arvoke.exports.recentUnfolded'

/** The signed-in person, from Clerk's own global (these are per person). */
function personId(): string {
  const clerk = (window as { Clerk?: { user?: { id?: string } | null } }).Clerk
  return clerk?.user?.id ?? 'anonymous'
}

function readFlag(key: string): boolean {
  try {
    return window.localStorage.getItem(`${key}.${personId()}`) === '1'
  } catch {
    return false
  }
}

function writeFlag(key: string, on: boolean): void {
  try {
    if (on) window.localStorage.setItem(`${key}.${personId()}`, '1')
    else window.localStorage.removeItem(`${key}.${personId()}`)
  } catch {
    // Storage refused: the default comes back next time, which is harmless.
  }
}

export function hasDraggedOut(): boolean {
  return readFlag(DRAG_HINT_KEY)
}

export function markDraggedOut(): void {
  writeFlag(DRAG_HINT_KEY, true)
}

/** Whether the person unfolded Recent Exports themselves: it opens unfolded from then on. */
export function keepsRecentUnfolded(): boolean {
  return readFlag(KEEP_UNFOLDED_KEY)
}

/** Unfolding keeps it open next time; folding goes back to the default (folded unless new). */
export function rememberRecentUnfolded(unfolded: boolean): void {
  writeFlag(KEEP_UNFOLDED_KEY, unfolded)
}
